module.exports = __webpack_public_path__ + "static/img/4bg_4.3be3d85.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_4.png
// module id = 715
// module chunks = 1